// extracted by mini-css-extract-plugin
export default {"tabs":"_2tPFi","tab":"o92wf","small":"_20-y9","medium":"_1XKX_","large":"zf3KU","disabled":"_2C4gn","active":"_1Th-P"};